/**
 * AB#10942 — Hub mirror of Rules `parent_read_access_scope`.
 * Keep in sync with server/app/config/parent_read_access_scope.py
 * Prefer GET /facility-network/read-access-scope when available; this is fallback.
 */

export type ParentReadScopeItem = {
  key: string;
  title: string;
  body: string;
  shared: boolean;
};

export const PARENT_READ_SCOPE_ITEMS: ParentReadScopeItem[] = [
  {
    key: "compliance_scores",
    title: "Compliance scores",
    body: "Overall compliance score, item counts, and quarter-over-quarter trend",
    shared: true,
  },
  {
    key: "active_deficiencies",
    title: "Active deficiencies",
    body: "Open citations, severity level, plan of correction status, resolution deadlines",
    shared: true,
  },
  {
    key: "facility_profile",
    title: "Facility profile",
    body: "Name, address, CCN, NPI, license status, facility type classification",
    shared: true,
  },
  {
    key: "staff_records",
    title: "Individual staff records",
    body: "Not shared — payroll, licensure, personnel files stay with you",
    shared: false,
  },
  {
    key: "survey_outcomes",
    title: "Survey outcomes",
    body: "Recent survey dates, findings, and citations (F-tags for SNF/CAH, OSV for FQHC/RHC)",
    shared: true,
  },
  {
    key: "penalty_history",
    title: "Penalty history",
    body: "CMPs, VBP adjustments, Denied Payment Days — CMS-reported penalties only",
    shared: true,
  },
  {
    key: "upcoming_surveys",
    title: "Upcoming surveys",
    body: "Scheduled survey windows and recertification due dates",
    shared: true,
  },
  {
    key: "patient_data",
    title: "Patient data & financials",
    body: "Not shared — clinical records, revenue, non-CMS financials stay with you",
    shared: false,
  },
];

/** Short prose for accept panels — derived from allowed keys only. */
export function parentReadScopeAcceptSummary(): string {
  const allowed = PARENT_READ_SCOPE_ITEMS.filter((item) => item.shared)
    .map((item) => item.title.toLowerCase())
    .join(", ");
  return `Accepting establishes a parent-child link. The parent facility will have read access to your ${allowed}. They cannot modify your data. The link can be removed at any time by either party.`;
}

export const PARENT_READ_SCOPE_BULLETS: string[] = PARENT_READ_SCOPE_ITEMS.filter(
  (item) => item.shared,
).map((item) => item.title);
